require("core-js/modules/esnext.global-this.js");

!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).Play = e.Play || {}, e.Play.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function l(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  function a(e) {
    if (e && e.__esModule) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var l = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, l.get ? l : {
          enumerable: !0,
          get: function get() {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }

  var n = a(e),
      i = l(r);

  function o(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }

  function u() {
    return u = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var l in t) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }

      return e;
    }, u.apply(this, arguments);
  }

  function f(e, r) {
    if (null == e) return {};

    var t,
        l,
        a = function (e, r) {
      if (null == e) return {};
      var t,
          l,
          a = {},
          n = Object.keys(e);

      for (l = 0; l < n.length; l++) {
        t = n[l], r.indexOf(t) >= 0 || (a[t] = e[t]);
      }

      return a;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);

      for (l = 0; l < n.length; l++) {
        t = n[l], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
      }
    }

    return a;
  }

  function c(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }

  var s,
      b,
      p = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  var d = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
      y = function y(e) {
    var r,
        l = e.className,
        a = e.size,
        i = void 0 === a ? 16 : a,
        y = e.title,
        g = e["aria-label"],
        m = e["aria-labelledby"],
        O = e.fill,
        v = e.role,
        j = void 0 === v ? "img" : v,
        h = f(e, d),
        P = t.css(s || (s = c(["\n    color: ", ";\n  "])), O),
        w = t.css(b || (b = c(["\n    flex-shrink: 0;\n  "]))),
        x = function (e, r, t) {
      var l,
          a,
          n = t["aria-label"],
          i = t["aria-labelledby"],
          u = t.title;

      switch (e) {
        case "img":
          return n || i || u ? (o(l = {}, "aria-labelledby", i), o(l, "aria-label", n), o(l, "title", u), l) : {
            "aria-label": (a = r, "".concat(a.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
          };

        case "presentation":
          return {
            "aria-hidden": !0,
            alt: ""
          };
      }
    }(j, "Play", (o(r = {
      title: y
    }, "aria-label", g), o(r, "aria-labelledby", m), r));

    return n.createElement("svg", u({
      className: t.cx(o({}, P, null != O), w, l),
      height: "number" == typeof i ? i : p[i],
      width: "number" == typeof i ? i : p[i],
      role: j
    }, x, h, {
      viewBox: "0 0 16 16"
    }), n.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.7789 6.70433C14.7711 7.28315 14.7711 8.71685 13.7789 9.29567L6.25581 13.6841C5.25582 14.2674 4 13.5461 4 12.3884L4 3.61155C4 2.45387 5.25582 1.73256 6.25581 2.31589L13.7789 6.70433Z",
      fill: "currentColor"
    }));
  };

  return y.displayName = "Play", y.isGlyph = !0, y.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, y;
});